function generateMessage(item: string, template: string) {
  return `${item}${template}`;
}

export function generateLengthMessage(item: string, length: string) {
  return `${item}は${length}で入力してください`;
}

// テンプレート
export const TEMPLATE_REQUIRED_INPUT = 'を入力してください';
export const TEMPLATE_REQUIRED_SELECT = 'を選択してください';

// 処理失敗
export const INVALID_CREDENTIALS = '認証情報が不正なため処理を中断しました';
export const INVALID_RESPONSE = 'サーバーからのレスポンスが不正なため処理を中断しました';
export const CONFLICT = '対象のデータが変更されているため画面を更新して下さい';
export const SEND_MAIL_FAILURE = 'メールの送信に失敗しました';
export const UPDATE_PASSWORD_FAILURE = 'パスワードの更新に失敗しました';
export const PRE_REGISTER_FAILURE = '仮会員登録に失敗しました';
export const LOGIN_FAILURE = 'IDまたはパスワードが違います';
export const RESET_PASSWORD_FAILURE = 'パスワードの再設定に失敗しました';
export const INVALID_TOKEN_OR_BIRTHDAY = '生年月日が違うかトークンが無効なため再設定に失敗しました';
export const INVALID_EXAM_QUANTITY = '個数が適正範囲外です。1～100 の数字を指定してください';
export const INVALID_GOODS_QUANTITY = '個数が適正範囲外です。1～100 の数字を指定してください';
export const REQUIRED_GOODS_OPTION = '選択してください';

// アカウント バリデーションエラー
export const REQUIRED_MAIL_ADDRESS = generateMessage('メールアドレス', TEMPLATE_REQUIRED_INPUT);
export const REQUIRED_MAIL_ADDRESS_CONFIRM = generateMessage('メールアドレス（確認）', TEMPLATE_REQUIRED_INPUT);
export const REQUIRED_LOGIN_ID = generateMessage('ID', TEMPLATE_REQUIRED_INPUT);
export const REQUIRED_PASSWORD = generateMessage('パスワード', TEMPLATE_REQUIRED_INPUT);
export const REQUIRED_PASSWORD_CONFIRM = generateMessage('パスワード（確認）', TEMPLATE_REQUIRED_INPUT);
export const REQUIRED_CURRENT_PASSWORD = generateMessage('現在のパスワード', TEMPLATE_REQUIRED_INPUT);
export const REQUIRED_GENDER = generateMessage('性別', TEMPLATE_REQUIRED_SELECT);
export const REQUIRED_BIRTHDAY = generateMessage('生年月日', TEMPLATE_REQUIRED_SELECT);
export const REQUIRED_LAST_NAME = generateMessage('氏名（姓）', TEMPLATE_REQUIRED_INPUT);
export const REQUIRED_FIRST_NAME = generateMessage('氏名（名）', TEMPLATE_REQUIRED_INPUT);
export const REQUIRED_LAST_NAME_KANA = generateMessage('氏名フリガナ（姓）', TEMPLATE_REQUIRED_INPUT);
export const REQUIRED_FIRST_NAME_KANA = generateMessage('氏名フリガナ（名）', TEMPLATE_REQUIRED_INPUT);
export const REQUIRED_POSTAL_CODE = generateMessage('郵便番号', TEMPLATE_REQUIRED_INPUT);
export const REQUIRED_PREFECTURE = generateMessage('都道府県', TEMPLATE_REQUIRED_SELECT);
export const REQUIRED_CITY = generateMessage('市区町村', TEMPLATE_REQUIRED_INPUT);
export const REQUIRED_STREET = generateMessage('番地', TEMPLATE_REQUIRED_INPUT);
export const REQUIRED_PHONE_NUMBER = generateMessage('電話番号', TEMPLATE_REQUIRED_INPUT);

export const LOGIN_ID_LENGTH = generateLengthMessage('ID', '3文字以上、30文字以下');
export const PASSWORD_LENGTH = generateLengthMessage('パスワード', '8文字以上');
export const NAME_LENGTH = generateLengthMessage('氏名', '合計20文字以内');
export const NAME_KANA_LENGTH = generateLengthMessage('氏名フリガナ', '合計20文字以内');
export const POSTAL_CODE_LENGTH = generateLengthMessage('郵便番号', '7文字以下');
export const PREFECTURE_LENGTH = generateLengthMessage('都道府県', '4文字以下');
export const CITY_LENGTH = generateLengthMessage('市区町村', '255文字以下');
export const STREET_LENGTH = generateLengthMessage('番地', '255文字以下');
export const BUILDING_NAME_LENGTH = generateLengthMessage('建物名・部屋番号', '255文字以下');
export const PHONE_NUMBER_LENGTH = generateLengthMessage('電話番号', '各4文字以下');

export const UPDATE_USERINFO_TOKEN_VERIFY_PROGRESS = '認証文字列の確認中です……';
export const UPDATE_USERINFO_TOKEN_VERIFY_SUCCESS = '認証文字列の確認が完了しました';
export const UPDATE_USERINFO_TOKEN_VERIFY_FAILURE = '更新用の認証文字列が確認できませんでした';
export const UPDATE_USERINFO_TOKEN_SEND = 'メールを送信しました。認証文字列を確認して入力してください';
export const UPDATE_USERINFO_TOKEN_SEND_FAILURE = '更新用の認証文字列のメール送信に失敗しました';
export const UPDATE_USERINFO_TOKEN_NOT_VERIFIED = 'メール認証が確認できませんでした。再認証してください';
export const LOGIN_ID_STRING_TYPE = 'IDは半角英小文字、半角数字、アンダースコア（_）のみ使用できます';
export const PASSWORD_STRING_TYPE = 'パスワードは「英大文字」「英小文字」「数字または記号」のみ使用でき、すべてを含む必要があります';
export const NAME_STRING_TYPE = '氏名は全角で入力してください';
export const NAME_KANA_STRING_TYPE = '氏名フリガナは全角カタカナで入力してください';
export const POSTAL_CODE_STRING_TYPE = '郵便番号はハイフンなしの半角数字で入力してください';
export const PHONE_NUMBER_STRING_TYPE = '電話番号は半角数字で入力してください';

export const EXISTS_ID = 'すでにIDが使われています';
export const ILLEGAL_MAIL_ADDRESS = 'メールアドレスの形式が不正です';
export const MAIL_ADDRESS_MISMATCH = 'メールアドレスとメールアドレス（確認）が一致していません';
export const PASSWORD_MISMATCH = 'パスワードとパスワード（確認）が一致していません';
export const NEW_PASSWORD_MISMATCH = '新しいパスワードと新しいパスワード（確認）が一致していません';
export const MAIL_NO_CHANGE = '現在のメールアドレスと同一のメールアドレスです';
export const INVALID_TOKEN_OR_PASSWORD = 'パスワードが違うかトークンが無効なため更新に失敗しました';
export const INVALID_BIRTHDAY = '生年月日が不正な日付です';
export const INCLUDE_INVALID_STRING = '使用できない文字が含まれています';
